export default "__VITE_ASSET__CleY$eP5__"